/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneAdTemplate from 'base/components/standalone/AdTemplate';

export const DynamicStandaloneAdTemplate = StandaloneAdTemplate;
export type DynamicStandaloneAdTemplateProps = PropsFromComponent<typeof StandaloneAdTemplate>;

export const DynamicStandaloneAdTemplateWith = (extras: DynamicStandaloneExtras): typeof StandaloneAdTemplate => {
    return function DynamicStandaloneAdTemplate(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'AdTemplate');
        return <StandaloneAdTemplate {...mergeProps({ options: { theme } }, props)} />;
    }
}